import React from "react";

import { Link } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ButtonBase from "@mui/material/ButtonBase";
import {SortableElement} from 'react-sortable-hoc';
import { modquizPaths } from "../../index";

type SidebarObjectListItemProps = {
    classes?: any;
    object: any;
    subjectHashKey?: string;
};

const SidebarObjectListItem = ({
    classes,
    object,
    subjectHashKey = "",
}: SidebarObjectListItemProps) => {
    const link = subjectHashKey
        ? modquizPaths.quizObject(subjectHashKey, String(object._id))
        : modquizPaths.quizObject("", String(object._id));

    return (
        <Link to={link}>
            <ListItem component={ButtonBase} className={classes} sx={{ display: 'flex', width: '100%', justifyContent: 'flex-start' }}>
                <svg width="20" height="12">
                    <rect
                        x="0"
                        y="1"
                        rx="0"
                        ry="0"
                        width="20"
                        height="10"
                        style={{ stroke: "black", fill: "rgba(0,0,0,.1)" }}
                    />
                </svg>
                &nbsp;
                <ListItemText primary={object.title} />
            </ListItem>
        </Link>
    );
}

const SidebarObjectSortableListItem = SortableElement((props: any) => <SidebarObjectListItem {...props} />) 

export {
    SidebarObjectListItem, SidebarObjectSortableListItem
} 
